import DeveloperHubPage from '@/components/pages/admin/developer/Developer';
import exportsStatusPage from '@/components/pages/admin/exports/ExportsStatus';
import McpConnector from '@/components/pages/admin/McpConnector';

const developerRoutes = [
    {
        path: '/admin/developer',
        name: 'developer',
        component: DeveloperHubPage,
        meta: {
            title: 'developer',
            icon: 'test',
            roles: ['ROLE_ADMIN'],
            cms: ['FAUME', 'SHOPIFY'],
        },
    },
    {
        path: '/admin/developer/surveillance-exports',
        name: 'exports-status',
        component: exportsStatusPage,
        meta: {
            title: 'exports-surveillance',
            icon: 'download',
            roles: ['ROLE_ADMIN'],
            cms: ['FAUME', 'SHOPIFY'],
        },
    },
    {
        path: '/admin/developer/mcp-connector',
        name: 'developer-mcp-connector',
        component: McpConnector,
        meta: {
            title: 'mcp-connector',
            roles: ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN'],
            cms: ['FAUME', 'SHOPIFY'],
            backRoute: 'developer',
        },
    },
    {
        path: '/admin/exports',
        redirect: {
            name: 'exports-status',
        },
    },
    {
        path: '/compte/mcp-connector',
        redirect: {
            name: 'developer-mcp-connector',
        },
    },
];

export default developerRoutes;
